import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ContactFormService {
    
    constructor(private base: BaseService) { }

    getContactFormData() {
        return this.base.get('/api/contact-us');
    }
    
}